module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-box",
    class: {
      'app-box-class': _vm.isOpenLittleYellowManUi
    }
  }, [(_vm.orderStatus >= -1 && !_vm.isTimeout24Hours) ? [_c('div', {
    ref: _vm.mapDomId,
    staticClass: "orderlocation"
  }), _vm._v(" "), (_vm.isOpenLittleYellowManUi) ? _c('div', {
    staticClass: "mcDonaIds-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mcDonaIds-box-right"
  }, [(_vm.orderStatus > 1) ? _c('div', {
    staticClass: "phone-right"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.riderPhone
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/MacIcon_phone.png")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con-right"
  }, [(_vm.orderStatus >= -1 && _vm.orderStatus < 100) ? _c('p', [_vm._v("\n            预计送达"), _c('span', {
    staticClass: "ml"
  }, [_vm._v(_vm._s(_vm.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == -1 || _vm.orderStatus == 1) ? _c('p', [_c('span', {
    staticClass: "mr"
  }, [_vm._v(_vm._s(_vm.riderName))]), _vm._v("餐品正在制作中\n          ")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 2 || _vm.orderStatus == 3) ? _c('p', [_c('span', {
    staticClass: "mr"
  }, [_vm._v(_vm._s(_vm.riderName))]), _vm._v("骑手正赶往商家\n          ")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 4) ? _c('p', [_c('span', {
    staticClass: "mr"
  }, [_vm._v(_vm._s(_vm.riderName))]), _vm._v("骑手正在配送\n          ")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 100) ? _c('p', [_c('span', {
    staticClass: "mr"
  }, [_vm._v(_vm._s(_vm.riderName))]), _vm._v("订单已完成\n          ")]) : _vm._e()])])]) : _c('div', {
    staticClass: "rider-box"
  }, [_c('div', {
    staticClass: "rider-status-box"
  }, [(_vm.orderStatus >= -1 && _vm.orderStatus < 100) ? _c('p', {
    staticClass: "rider-delivery-time"
  }, [_vm._v("\n          预计送达"), _c('span', {
    staticClass: "delivery-time"
  }, [_vm._v(_vm._s(_vm.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 100) ? _c('p', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": require("./images/img_success.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == -1 || _vm.orderStatus == 1) ? _c('p', {
    staticClass: "rider-status-content"
  }, [_vm._v("\n          餐品正在制作中\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 2 || _vm.orderStatus == 3) ? _c('p', {
    staticClass: "rider-status-content"
  }, [_vm._v("\n          骑手正赶往商家\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 4) ? _c('p', {
    staticClass: "rider-status-content"
  }, [_vm._v("\n          骑手正在配送\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 100) ? _c('p', {
    staticClass: "rider-status-content"
  }, [_vm._v("\n          订单已完成\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.orderStatus > 1) ? _c('div', {
    staticClass: "rider-phone-box"
  }, [_c('div', {
    staticClass: "rider-phone-left"
  }, [_c('img', {
    attrs: {
      "src": require("./images/img_riderImg.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.riderName))])]), _vm._v(" "), _c('div', {
    staticClass: "rider-phone-right"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.riderPhone
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon_phone.png")
    }
  })])])]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.isTimeout24Hours || _vm.orderStatus == -100) ? [_c('div', {
    staticClass: "timeout-24hours"
  }, [(_vm.isTimeout24Hours) ? _c('img', {
    attrs: {
      "src": require("./images/img_timeout.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderStatus == -100 && !_vm.isTimeout24Hours) ? _c('img', {
    attrs: {
      "src": require("./images/img_cancel.png")
    }
  }) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.isErrorPage) ? [_vm._m(1)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mcDonaIds-box-left"
  }, [_c('img', {
    attrs: {
      "src": require("./images/minionsLogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('img', {
    attrs: {
      "src": require("./images/404.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f30118a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./core-dms/projects/candao-dms-std/orderLocation/index.vue
// module id = 562
// module chunks = 99